import { render, staticRenderFns } from "./NewsHeadline.vue?vue&type=template&id=561d978d&scoped=true"
import script from "./NewsHeadline.vue?vue&type=script&lang=js"
export * from "./NewsHeadline.vue?vue&type=script&lang=js"
import style0 from "./NewsHeadline.vue?vue&type=style&index=0&id=561d978d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561d978d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VCarousel,VCarouselItem,VSpacer})
